import { DocumentCategory, DocumentSubCategory } from 'shared';

import { StringKey } from '../../../lang/index';

// Direct re-export from source so Babel (isolatedModules) keeps these as value bindings.
export {
  DocumentCategory,
  DocumentLinkedEventKind,
  DocumentSubCategory,
  isDocumentSubCategory,
} from 'shared';

export const documentCategoryLabelKey: Record<DocumentCategory, StringKey> = {
  [DocumentCategory.BUYBACK]: 'BUYBACK',
  [DocumentCategory.CLASS_CONVERSION]: 'CLASS_CONVERSION',
  [DocumentCategory.FUNDRAISING_ROUND]: 'FUNDRAISING_ROUND',
  [DocumentCategory.GRANT]: 'GRANT',
  [DocumentCategory.OTHER]: 'OTHER',
  [DocumentCategory.PLANS]: 'PLANS',
  [DocumentCategory.POOLS]: 'POOLS',
  [DocumentCategory.SAFE]: 'SAFE',
  [DocumentCategory.SECONDARIES]: 'SECONDARIES',
  [DocumentCategory.SHARE_CLASSES]: 'SHARE_CLASSES',
  [DocumentCategory.SHARE_ISSUANCE]: 'SHARE_ISSUANCE',
  [DocumentCategory.VALUATION_EVENT]: 'VALUATION_EVENT',
};

export const documentSubCategoryLabelKey: Record<DocumentSubCategory, StringKey> = {
  [DocumentSubCategory.BUYBACK_BOARD_RESOLUTION]: 'BOARD_RESOLUTION',
  [DocumentSubCategory.BUYBACK_SHARE_REPURCHASE_AGREEMENT]: 'SHARE_REPURCHASE_AGREEMENT',
  [DocumentSubCategory.CLASS_CONVERSION_BOARD_RESOLUTION]: 'BOARD_RESOLUTION',
  [DocumentSubCategory.FUNDRAISING_ROUND_SHAREHOLDER_AGREEMENT]: 'SHAREHOLDER_AGREEMENT',
  [DocumentSubCategory.FUNDRAISING_ROUND_SUBSCRIPTION_AGREEMENT]: 'SUBSCRIPTION_AGREEMENT',
  [DocumentSubCategory.GRANT_AGREEMENT]: 'GRANT_AGREEMENT',
  [DocumentSubCategory.GRANT_EXERCISE_NOTICE]: 'EXERCISE_NOTICE',
  [DocumentSubCategory.GRANT_HURDLE_APPROVAL]: 'HURDLE_APPROVAL',
  [DocumentSubCategory.GRANT_PHANTOM_PAYOUT]: 'PHANTOM_PAYOUT',
  [DocumentSubCategory.OTHER_OTHER]: 'OTHER',
  [DocumentSubCategory.PLANS_BOARD_RESOLUTION]: 'BOARD_RESOLUTION',
  [DocumentSubCategory.PLANS_PLAN_AGREEMENT]: 'PLAN_AGREEMENT',
  [DocumentSubCategory.POOLS_BOARD_RESOLUTION]: 'BOARD_RESOLUTION',
  [DocumentSubCategory.SAFE_SAFE_AGREEMENT]: 'SAFE_AGREEMENT',
  [DocumentSubCategory.SAFE_SAFE_CONVERSION_NOTICE]: 'SAFE_CONVERSION_NOTICE',
  [DocumentSubCategory.SECONDARIES_BOARD_RESOLUTION]: 'BOARD_RESOLUTION',
  [DocumentSubCategory.SECONDARIES_PURCHASE_AND_SELL_AGREEMENT]: 'PURCHASE_AND_SELL_AGREEMENT',
  [DocumentSubCategory.SHARE_CLASSES_BOARD_RESOLUTION]: 'BOARD_RESOLUTION',
  [DocumentSubCategory.SHARE_ISSUANCE_BOARD_RESOLUTION]: 'BOARD_RESOLUTION',
  [DocumentSubCategory.SHARE_ISSUANCE_SHARE_CERTIFICATE]: 'SHARE_CERTIFICATE',
  [DocumentSubCategory.VALUATION_EVENT_BOARD_RESOLUTION]: 'BOARD_RESOLUTION',
};
